function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff",
      fillopacity: 1,
      stroke: "none",
      strokeWidth: 0.54166669
    },
    cx: 12,
    cy: 12,
    r: 6.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAll);
export default __webpack_public_path__ + "static/media/icon_all.c28cbb53ec6dc02b6d798f3ad71317bc.svg";
export { ForwardRef as ReactComponent };